// import { defineCancelApiObject } from './configs/axiosUtils';
import { callApi } from '../../apiCaller';
import { toastError } from '../../utils';

const VOUCHER_RULE_ENDPOINT = 'voucher-rules';

export const VoucherRuleAPI = {
     get: async (id, cancel = false) => {
          const endpoint = `${VOUCHER_RULE_ENDPOINT}/:id`.replace(':id', id);

          // // Retrieving the signal value by using the property name
          // signal: cancel ? cancelApiObject[this.get.name].handleRequestCancellation().signal : undefined,
          return await callApi(endpoint, 'GET').then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               return response.data;
          });
     },
     getAll: async (filterPayload, cancel = false) => {
          const { page, pageSize, queryFilter, sortBy, sortType } = filterPayload;

          const endpoint = `${VOUCHER_RULE_ENDPOINT}/data-lists?page=${page}&pageSize=${pageSize}${queryFilter}&sortBy=${sortBy}&sortType=${sortType}`;

          return await callApi(endpoint, 'GET').then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               return response.data;
          });
     },
     create: async (payload, cancel = false) => {
          const endpoint = VOUCHER_RULE_ENDPOINT;

          return await callApi(endpoint, 'POST', payload).then((response) => {
               if (response.status !== 200) {
                    if (response.data.errors.some((err) => err.message === 'Name is existed!')) {
                         return 'Name is existed!';
                    }

                    toastError(response);
                    return;
               }

               return response.data;
          });
     },
     update: async (payload, cancel = false) => {
          const { id, ...restPayload } = payload;
          const endpoint = `${VOUCHER_RULE_ENDPOINT}/${id}`;

          return await callApi(endpoint, 'PATCH', restPayload).then((response) => {
               if (response.status !== 200) {
                    if (response.data.errors.some((err) => err.message === 'Name is existed!')) {
                         return 'Name is existed!';
                    }

                    toastError(response);
                    return;
               }

               return response.data;
          });
     },
     delete: async (id) => {
          const endpoint = `${VOUCHER_RULE_ENDPOINT}/${id}`;

          return await callApi(endpoint, 'DELETE').then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               return response.data;
          });
     },
     lookup: async (payload, cancel = false) => {
          const endpoint = `${VOUCHER_RULE_ENDPOINT}/lookup`;

          return await callApi(endpoint, 'POST', payload).then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               return response.data;
          });
     },
};

// // Defining the cancel API object for VoucherRuleAPI
// const cancelApiObject = defineCancelApiObject(VoucherRuleAPI);
